import { useEffect, useRef } from 'react'
import { InnerInputWrapper } from './index.style'

function InnerInput (props) {
  const {
    placeholder, backgroundColor, errorField,
    className, name, displayBorder, defaultValue,
    opacity, value, isControlled, ...rest
  } = props

  const inputRef = useRef(null)

  useEffect(() => {
    if (isControlled && !!defaultValue) {
      // If field is controlled, always replace with defaultValue
      inputRef.current.value = defaultValue
    }
    if (!!defaultValue && !inputRef.current?.value) {
      // If input is still empty, when defaultValue is changed, reset with defaultValue
      inputRef.current.value = defaultValue
    }
  }, [defaultValue, isControlled])

  return (
    <InnerInputWrapper
      ref={inputRef}
      name={name}
      error={errorField === name}
      backgroundColor={backgroundColor}
      defaultValue={defaultValue}
      opacity={opacity}
      displayBorder={displayBorder}
      className={className}
      value={value}
      placeholder={placeholder || 'Masukkan sesuatu..'}
      {...rest}
    />
  )
}

export default InnerInput
